import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTimes = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.32812 7L13.1719 11.8438C13.2109 11.9219 13.25 12 13.25 12.0781C13.25 12.1562 13.2109 12.2344 13.1719 12.2734L12.2734 13.1719C12.1953 13.25 12.1172 13.25 12.0391 13.25C11.9609 13.25 11.8828 13.25 11.8438 13.1719L7 8.32812L2.15625 13.1719C2.07812 13.25 2 13.25 1.92188 13.25C1.84375 13.25 1.76562 13.25 1.72656 13.1719L0.828125 12.2734C0.75 12.2344 0.75 12.1562 0.75 12.0781C0.75 12 0.75 11.9219 0.828125 11.8438L5.67188 7L0.828125 2.15625C0.75 2.11719 0.75 2.03906 0.75 1.96094C0.75 1.88281 0.75 1.80469 0.828125 1.72656L1.72656 0.828125C1.76562 0.789062 1.84375 0.75 1.92188 0.75C2 0.75 2.07812 0.789062 2.15625 0.828125L7 5.67188L11.8438 0.828125C11.8828 0.789062 11.9609 0.75 12.0391 0.75C12.1172 0.75 12.1953 0.789062 12.2734 0.828125L13.1719 1.72656C13.2109 1.80469 13.25 1.88281 13.25 1.96094C13.25 2.03906 13.2109 2.11719 13.1719 2.15625L12.3516 2.97656L8.32812 7Z",
		fill: "currentColor"
	})
});
export default SvgTimes;
